/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `DP` - Documents Against Payment
* `LC` - Letter of Credit
* `TT` - Telegraphic Transfer
 */
export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];


export const PaymentMethod = {
  DP: 'DP',
  LC: 'LC',
  TT: 'TT',
} as const;
